import { createSelector } from '@reduxjs/toolkit';
import {
  getOrganization,
  personalDataItemsNotDeleted,
  type PersonalDataItemViewModelExtended,
  substancesNotDeleted,
} from 'src/store/selectors';
import type { OrganizationPropertiesForSuggestions } from 'src/store/selectors/conditional/conditional';
import type { OrganizationState } from 'src/store/types';
import type { SubstanceViewModel } from '@trinnvis/dabih-api-client';

export const organizationDataForSuggestions = createSelector(
  getOrganization,
  substancesNotDeleted,
  personalDataItemsNotDeleted,
  function (
    organization: OrganizationState | undefined,
    substances: SubstanceViewModel[],
    personalDataItems: PersonalDataItemViewModelExtended[],
  ): OrganizationPropertiesForSuggestions {
    return {
      sector: organization?.sector ?? '',
      features: organization?.features ?? [],
      substances,
      personalDataItems,
    };
  },
);
